import t from "assets/videos/animated_1.gif";
import { Slide } from "react-reveal";

const About = () => {
  return (
    <section id="about">
      <div className="container">
        <div className="row about-row about-row1">
          <div className="about-left">
            <div className="description">
              {/* <img className="animated_assets" src={t} alt="" /> */}
              <Slide bottom>  <h2>WELCOME TO THE <div className="colored">Meta Masks NFT !</div></h2></Slide>
              <Slide bottom>
                <p>Meta Masks has been developed by a team of entrepreneurs, marketing experts, artists who have extensive experience and Blockchain specialists. The team is devoted to the community and making this project a success like no other</p>
              </Slide>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
